/* eslint-disable import/no-cycle */
import { utils } from 'crux';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import { validateInnerHtml } from '../../../utils';
import GetElementFunc from '../../../util/GetElement';
import { getValidators } from '../../../cruxComponents/utils';
import NestedListQuestions from '../../List/NestedListQuestions';
// import { setNestedParentListIndices } from '../../../redux/actions/questions';

const Row = styled.div`
  margin-bottom: 25px;
  display: flex;
  justify-content: ${({ rowTheme }) => (rowTheme && rowTheme.justifyContent) || 'space-between'};
  align-items: center;
  @media (min-width: 481px) and (max-width: 766px) {
    flex-direction: row;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    margin-bottom: 30px;
    align-items: flex-start;
  }
`;

const Label = styled.div`
  margin: 0;
  width: 50%;
  ${({ labelTheme }) => labelTheme || 'font-size: 18px; font-weight: 500;color: #262d3f;'};
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`;

const Value = styled.div`
  margin: 0;
  ${({ valueTheme }) =>
    valueTheme || 'font-size: 18px; font-weight: 600;padding-left: 75px;color: #262d3f;'};
  @media only screen and (max-width: 480px) {
    padding-left: 0;
    width: 100%;
    margin: 0;
  }
  word-break: break-word;
`;

const getNestedListQuestion = (question, nestedListProps) => {
  const { isEditMode, sectionIndex, isReview, changeMode, listIndex, updateEditIndex } =
    nestedListProps;
  const questionsCompletedFlag = get(question, 'child_questions_completed_flag', false);
  const isParentListInEditMode = isEditMode;
  if (!isParentListInEditMode && !questionsCompletedFlag) {
    updateEditIndex(listIndex);
  }
  return (
    <NestedListQuestions
      name='nested-list-questions'
      item={ question }
      sectionIndex={ sectionIndex }
      isReview={ isReview }
      changeMode={ changeMode }
      isNestedQ
      showListActions={ isParentListInEditMode }
      parentListIndex={ listIndex }
    />
  );
};

const getResponse = (question) => {
  if (isObject(question.response)) {
    return question.response?.label;
  }
  if (get(question, 'validations.mask.mask_on_blur')) {
    const validators = getValidators(question);
    return utils.maskInputValue({ ...validators }, question.response);
  }
  const responseText = question.response;
  const metricValue = get(question, 'validations.metric.value', '');
  const suffixValue = get(question, 'validations.suffix.value', '');
  if (metricValue) {
    return `${metricValue}${responseText}`;
  }
  if (suffixValue) {
    return `${responseText}${suffixValue}`;
  }
  return `${responseText}`;
};

function FieldSet(props) {
  const { fieldSetProps, theme } = props;
  const {
    fields,
    isEditMode,
    sectionIndex,
    index: listIndex,
    listParentId,
    changeMode,
    isReview,
    isNestedQ,
    parentListIndex,
    updateEditIndex,
  } = fieldSetProps;
  const nestedListProps = {
    isEditMode,
    sectionIndex,
    isReview,
    changeMode,
    listIndex,
    updateEditIndex,
  };

  const { config, pageId } = theme;
  const {
    row: rowTheme,
    label: labelTheme,
    value: valueTheme,
  } = get(config, ['theme', 'pageOverrides', pageId, 'fieldSetTheme'], {});
  if (isEditMode) {
    return (
      <>
        {fields.map((question) => {
          if (question.display_type === 'list') {
            return getNestedListQuestion(question, nestedListProps);
          }
          if (question.is_hidden) return null;
          return (
            <GetElementFunc
              questionObj={ question }
              sectionIndex={ sectionIndex }
              required
              isEditMode
              listParentId={ listParentId }
              listIndex={ listIndex }
              parentListIndex={ isNestedQ ? parentListIndex : null }
            />
          );
        })}
      </>
    );
  }
  return (
    <>
      {fields.map((question) => {
        if (question.display_type === 'list') {
          return getNestedListQuestion(question, nestedListProps);
        }
        return (
          <Row
            name='row'
            key={ question.question_id }
            className={ question.className }
            rowTheme={ rowTheme }
          >
            <Label
              name='label'
              htmlFor={ question.question_id }
              dangerouslySetInnerHTML={ { __html: validateInnerHtml(question.question_text) } }
              labelTheme={ labelTheme }
            />
            <Value label='value' valueTheme={ valueTheme }>
              {getResponse(question)}
            </Value>
          </Row>
        );
      })}
    </>
  );
}

export default withTheme(FieldSet);
